import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import EmptyLine from "../EmptyLine";

export function B9({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XY01.error_id: {
            return (
                <>
                    <ResultText>Georeferencing of the following {row?.data?.length} cross sections are missing:</ResultText>
                    <ResultText><CheckCSName csNameList={row.data.map(x => x.cross_section)} /></ResultText>
                </>
            )
        }
        case MessageCodes.Internal.XY16.error_id: {
            return (
                <>
                    <ResultText>The reach invert line (stream centerline) is not in the US to DS direction</ResultText>
                    {/*{row?.data.length > 0 && (*/}
                    {/*    <>*/}
                    {/*        <EmptyLine height={8}/>*/}
                    {/*        <ResultText>*/}
                    {/*            <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />*/}
                    {/*        </ResultText>*/}
                    {/*    </>*/}
                    {/*)}*/}
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}